import React from "react";
import { Button } from "../../components/ui/button";
import { Link } from "react-router-dom";
import { CheckSquare, Bot, GitMerge } from "lucide-react";

const ActionItems = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          From Discussions to Done—Automated Action Items
        </h1>
        
        <div className="grid md:grid-cols-2 gap-16 mt-12">
          <div>
            <h2 className="text-2xl font-semibold mb-6">Key Features</h2>
            <div className="space-y-6">
              <div className="flex gap-4">
                <CheckSquare className="h-6 w-6 text-primary shrink-0" />
                <div>
                  <h3 className="font-medium mb-2">Manual & Automated Tasks</h3>
                  <p className="text-muted-foreground">
                    Add tasks manually or let AI extract them automatically from your meeting notes.
                  </p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <GitMerge className="h-6 w-6 text-primary shrink-0" />
                <div>
                  <h3 className="font-medium mb-2">Advanced Task Management</h3>
                  <p className="text-muted-foreground">
                    Create sub-tasks, set dependencies, and link resources for comprehensive project management.
                  </p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <Bot className="h-6 w-6 text-primary shrink-0" />
                <div>
                  <h3 className="font-medium mb-2">AI Task Completion</h3>
                  <p className="text-muted-foreground">
                    Premium feature that automates task execution like sending emails and scheduling meetings.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-6">Use Cases</h2>
            <div className="space-y-6">
              <div className="p-6 rounded-lg bg-card">
                <h3 className="font-medium mb-2">Project Management</h3>
                <p className="text-muted-foreground">
                  Turn your project meeting into a detailed to-do list, automatically extracted and organized.
                </p>
              </div>
              
              <div className="p-6 rounded-lg bg-card">
                <h3 className="font-medium mb-2">Task Tracking</h3>
                <p className="text-muted-foreground">
                  Never forget a task—AI tracks progress and sends reminders to keep you on schedule.
                </p>
              </div>
            </div>
            
            <div className="mt-8">
              <Button asChild size="lg">
                <Link to="/pricing">Explore AI Task Management</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionItems;